import axios from "axios";

// Attaches this browser's restaurant-app login token to every request made
// through the plain `axios` import (GeneralService, userService,
// StockService). Read fresh from localStorage on each request rather than
// cached, so it's always correct across login/logout without extra wiring.
// Imported once, for its side effect, near app start (see App.js).
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
